// mutations.js

export default {
   updateCurrentUser(state, payload){
       console.log('апдейтим юзера: ', payload)
       state.currentUser.id = payload.id
       state.currentUser.name = payload.name
       state.currentUser.email = payload.email
       state.currentUser.email_verified_at = payload.email_verified_at
       state.currentUser.created_at = payload.created_at
       state.currentUser.updated_at = payload.updated_at
       state.currentUser.role_id = payload.role_id
       state.currentUser.role_code = payload.role_code
   }
 
};
